import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'DELETE_COMPANY_VEHICLE_TYPE_',
  }
);

export interface DeleteCompanyVehicleTypeState {
  id: number | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface DeleteCompanyVehicleTypeRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: DeleteCompanyVehicleTypeState = {
  id: null,
  loading: false,
  errorMessage: null,
};

const request = (
  state: DeleteCompanyVehicleTypeState,
  action: DeleteCompanyVehicleTypeRequestAction
) =>
  update(state, {
    id: { $set: action.id },
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: DeleteCompanyVehicleTypeState) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
  });

const failure = (state: DeleteCompanyVehicleTypeState, action: FailureAction) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: DeleteCompanyVehicleTypeState) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const deleteCompanyVehicleType = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const DeleteCompanyVehicleTypeTypes = Types;
export const DeleteCompanyVehicleTypeActions = Creators;
